import { Component, OnInit } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { WidgetService } from '../../services/widget.service';
import { DisplayService } from '../../services/display.service';
import { WIDGET_ID } from '../../utils/constant';
@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {
  color: '#eee';
  activeCat = '';
  categoryData = {};
  activeQuestionIndex = 0;
  progress = 0;
  questonaireData = {};
  backGroundImage = '';
  categoryList = [];

  constructor(
    private stateService: AppStateService,
    private router: Router,
    private route: ActivatedRoute,
    private service: WidgetService,
    private display: DisplayService
  ) {

  }

  ngOnInit(): void {
    this.activeCat = this.route.snapshot.paramMap.get('slug');
    this.stateService.setActiveCategory(this.activeCat);
    this.stateService.getCategoriesData().subscribe(val => {
      this.categoryData = val;
    });

    this.stateService.getCategoryList().subscribe(list => {
      this.categoryList = list;
    });

    if (this.activeCat.indexOf('sleep') > -1) {
      this.backGroundImage = 'assets/images/category/sleep.png';
    } else if (this.activeCat.indexOf('nutrition') > -1) {
      this.backGroundImage = 'assets/images/category/nutrition.png';
    }
    else if (this.activeCat.indexOf('stress') > -1) {
      this.backGroundImage = 'assets/images/category/stress.png';
    }
    else if (this.activeCat.indexOf('life') > -1) {
      this.backGroundImage = 'assets/images/category/life.png';
    }
    else if (this.activeCat.indexOf('movement') > -1) {
      this.backGroundImage = 'assets/images/category/human-movement.png';
    }
    else if (this.activeCat.indexOf('hormones') > -1) {
      this.backGroundImage = 'assets/images/category/hormones.png';
    }
    else if (this.activeCat.indexOf('environment') > -1) {
      this.backGroundImage = 'assets/images/category/environment.png';
    }
    else if (this.activeCat.indexOf('cognition') > -1) {
      this.backGroundImage = 'assets/images/category/cognition.png';
    }
  }

  onSelectOption(optionId: string, questionId: string) {
    this.progress = (100 / this.categoryData[this.activeCat].questions.length) * (this.activeQuestionIndex + 1);
    this.questonaireData[questionId] = optionId;
    if (this.activeQuestionIndex < (this.categoryData[this.activeCat].questions.length - 1)) {
      this.activeQuestionIndex = this.activeQuestionIndex + 1;
    } else if (this.activeQuestionIndex == (this.categoryData[this.activeCat].questions.length - 1)) {
      this.display.showLoader();
      const data = {
        data: this.questonaireData,
        contact: localStorage.getItem('user'),
        widget: WIDGET_ID,
        categoryId: this.categoryData[this.activeCat]._id,
        isLast: this.categoryList.indexOf(this.activeCat) == this.categoryList.length - 1
      };
      this.service.saveCategoryData(data).subscribe(res => {
        if (res && res.data) {
          localStorage.setItem(this.activeCat, res.data._id);
          this.router.navigate([`pages/result/${this.activeCat}`]);
        }
        this.display.hideLoader();
      }, err => {
        this.display.hideLoader();
        console.log(err);
      });


    }
  }

  onClickBack() {
    if (this.activeQuestionIndex > 0) {
      this.activeQuestionIndex = this.activeQuestionIndex - 1;
    }
    this.progress = (100 / this.categoryData[this.activeCat].questions.length) * (this.activeQuestionIndex);
  }

}
